module.exports = __webpack_public_path__ + "img/con3.423bd5ca.png";